import React from "react";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import urlPatterns from "../../urls";
import { WINE_LIST_SLUGS, WINE_CLASS_IDS } from "../../helpers/constants";

const WineListClass = ({ match }) => {
  const { params } = match || {};
  const { wineClassId } = params || {};

  // When we have a valid wine class id in params, we redirect to All wines with filter.
  if (wineClassId) {
    const id = parseInt(wineClassId, 10);
    if (Object.values(WINE_CLASS_IDS).includes(id)) {
      return (
        <Redirect
          to={{
            pathname: urlPatterns.WINE_LIST(WINE_LIST_SLUGS.ALL_WINES),
            state: { selectedFilters: { wineClassIds: [id] } },
          }}
        />
      );
    }
  }
  return <Redirect to={urlPatterns.WINE_LIST(WINE_LIST_SLUGS.ALL_WINES)} />;
};

WineListClass.propTypes = {
  match: PropTypes.shape({}).isRequired,
};

export default WineListClass;
